import { canUseDOM } from 'exenv';

import { createBrowserHistory, createMemoryHistory } from 'history';

const history = canUseDOM ? createBrowserHistory() : createMemoryHistory();

export default history;
